import uniq from 'lodash/uniq';
import without from 'lodash/without';
const defaultState = {
  __CLIENT_HYDRATED__: false,
  name: null,
  modals: [],
  openedModals: [],
  notificationPanelOpened: false,
};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case 'MODAL_OPENED':
      return {
        ...state,
        openedModals: uniq([payload, ...state.openedModals]),
      };
    case 'MODAL_CLOSED':
      return {
        ...state,
        openedModals: uniq(without(state.openedModals, payload)),
      };
    case 'MODAL_MOUNTED':
      return {
        ...state,
        modals: [...state.modals, payload]
      };

    case 'NOTIFICATION_PANEL_TOGGLE':
      return {
        ...state,
        notificationPanelOpened: !state.notificationPanelOpened,
      };
    case 'NOTIFICATION_PANEL_OPEN':
      return {
        ...state,
        notificationPanelOpened: true,
      };
    case 'NOTIFICATION_PANEL_CLOSE':
      return {
        ...state,
        notificationPanelOpened: false,
      };

    case 'CLIENT_HYDRATED':
      return {
        ...state,
        __CLIENT_HYDRATED__: true,
        ...payload
      };
    default:
      return state;
  }
};
